export default __webpack_public_path__ + "static/media/time_management_inactive.cead4962.svg";